<template>
  <!-- <vue-friendly-iframe scrolling="no" class="frame" :style="item" :src="frameSrc"></vue-friendly-iframe> -->
  <div class="frame" :style="item">
    <component :is="pageComponent" :pageParams="pageParams"></component>
    <!-- <div class="frame-child" v-if="protocol != 'page:'">
      <iframe v-if="!params.scroll" scrolling="no" class="iframe-scroll "  :src="frameSrc" target="_parent" :frameBorder="length>1?1:0" allowfullscreen></iframe>
      <iframe v-if="params.scroll"  class="iframe "  :src="frameSrc" target="_parent" :frameBorder="length>1?1:0" allowfullscreen></iframe>
    </div>
    <div class="frame-child"  v-else>
      <component :is="pageComponent" :pageParams="pageParams"></component>
    </div> -->
  </div>
</template>

<script>
import parse from 'url-parse';
import URI from 'urijs';
const Youtube = () => import('@/views/pages/Youtube.vue');
const Url = () => import('@/views/pages/Url.vue');
const Video = () => import('@/views/pages/Video.vue');
const Image = () => import('@/views/pages/Image.vue');
const Slider = () => import('@/views/pages/Slider.vue');
const Rss = () => import('@/views/pages/Rss.vue');
const Button = () => import('@/views/pages/Button.vue');
const Sticker = () => import('@/views/pages/Sticker.vue');
const Display = () => import('@/views/pages/Display.vue');
const List = () => import('@/views/pages/List.vue');
const Post = () => import('@/views/pages/Post.vue');
const View = () => import('@/views/pages/View.vue');
const Kanban = () => import('@/views/pages/Kanban.vue');
const Room = () => import('@/views/pages/Room.vue');
const Worker = () => import('@/views/pages/Worker.vue');
const Chart = () => import('@/views/pages/Chart.vue');
const Urt = () => import('@/views/pages/Urt.vue');
const YP = () => import('@/views/pages/Yp.vue');
const Objects = () => import('@/views/pages/Object.vue');
const Obj = () => import('@/views/pages/Obj.vue');
const Drop = () => import('@/views/pages/Drop.vue');
const Twin = () => import('@/views/pages/Twin.vue');
const Json = () => import('@/views/pages/Json.vue');
const Flow = () => import('@/views/pages/Flow.vue');
const Nearby = () => import('@/views/pages/Nearby.vue');
const Remote = () => import('@/views/pages/Remote.vue');
const SSTV = () => import('@/components/page-components/remote/SSTV.vue');
const SSTVConfig = () => import('@/components/page-components/remote/SSTVConfig.vue');
const JBSettings = () => import('@/components/page-components/touch/JBSettings.vue');
const JBControl = () => import('@/components/page-components/touch/JBControl.vue');
const Shortcut = () => import('@/components/page-components/touch/Shortcut.vue');
const Touch = () => import('@/views/pages/Touch.vue');
const DWI = () => import('@/views/pages/DWI.vue');
const Newaicam = () => import('@/views/pages/Newaicam.vue');
const Ob = () => import('@/components/page-components/remote/Ob.vue');
const PMStatus = () => import('@/views/pages/PM/PMStatus.vue');
const PMAction = () => import('@/views/pages/PM/PMAction.vue');
const tg = () => import('@/views/pages/tg.vue');
const PG360 = () => import('@/views/pages/360.vue');
const PDF = () => import('@/views/pages/Pdf.vue');
const Poster = () => import('@/views/pages/Poster2.vue');

//import VueFriendlyIframe from '@motebus/vue-friendly-iframe';
//import VueFriendlyIframe from 'vue-friendly-iframe';

export default {
  name: 'board-item',
  // components: {
  //   VueFriendlyIframe,
  // },
  props: {
    name: String,
    bid: String,
    menutitle: String,
    source: String,
    app: String,
    appinfo: Object,
    qdata: Object,
    params: Object,
    data: Object,
    size: Object,
    scroll: Boolean,
    row: Number,
    length: Number,
    dark:Boolean,
    autoplay:Boolean,
    loop:Boolean
  },
  data() {
    return {
      frameSrc: '#',
      item: {},
      header: false,
      hostname: null,
      protocol: null
    };
  },
  watch: {
    name: {
      immediate: true,
      handler() {
        this.dealUrl();
      },
    },
    app: {
      immediate: true,
      handler() {
        this.dealUrl();
      },
    },
    params: {
      immediate: true,
      handler() {
        this.dealUrl();
      },
    },
    data: {
      immediate: true,
      handler() {
        this.dealUrl();
      },
    },
    size: {
      immediate: true,
      handler() {
        this.dealSize();
      },
    },
  },
  computed: {
    pageComponent() {
      if(this.hostname == 'youtube') return Youtube;
      if(this.hostname == 'url') return Url;
      if(this.hostname == 'video') return Video;
      if(this.hostname == 'image') return Image;
      if(this.hostname == 'slider') return Slider;
      if(this.hostname == 'rss') return Rss;
      if(this.hostname == 'button') return Button;
      if(this.hostname == 'sticker') return Sticker;
      if(this.hostname == 'display') return Display;
      if(this.hostname == 'list') return List;
      if(this.hostname == 'post') return Post;
      if(this.hostname == 'view') return View;
      if(this.hostname == 'kanban') return Kanban;
      if(this.hostname == 'room') return Room;
      if(this.hostname == 'worker') return Worker;
      if(this.hostname == 'chart') return Chart;
      if(this.hostname == 'yp') return YP;
      if(this.hostname == 'json') return Json;
      if(this.hostname == 'flow') return Flow;
      if(this.hostname == 'urt') return Urt;
      if(this.hostname == 'pm') return PMStatus;
      if(this.hostname == 'pm/action') return PMAction;
      if(this.hostname == 'nearby') return Nearby;
      if(this.hostname == 'tg') return tg;
      if(this.hostname == 'remote') return Remote;
      if(this.hostname.startsWith('remote/tvconfig')) return SSTVConfig;
      if(this.hostname.startsWith('remote/tv')) return SSTV;
      if(this.hostname.startsWith('remote/ob')) return Ob;
      if(this.hostname == 'dwi') return DWI;
      if(this.hostname == 'aibot') return Newaicam;
      if(this.hostname == 'touch') return Touch;
      if(this.hostname.startsWith('touch/jbctl')) return JBControl;
      if(this.hostname.startsWith('touch/shortcut')) return Shortcut;
      if(this.hostname.startsWith('touch/settings')) return JBSettings;
      if(this.hostname == 'object') return Objects;
      if(this.hostname == 'obj') return Obj;
      if(this.hostname == 'upload') return Drop;
      if(this.hostname == 'twin') return Twin;
      if(this.hostname == '360') return PG360;
      if(this.hostname == 'pdf') return PDF;
      if(this.hostname == 'poster') return Poster;
    },
    pageParams() {
      return {
        bid: this.bid,
        menuTitle: this.menutitle,
        source: this.source,
        json: this.data,
        output: 'embed',
        dark: this.dark,
        playlist: this.hostname.slice(this.hostname.lastIndexOf('/') + 1),
        autoplay: this.autoplay,
        loop: this.loop,
        app: this.appinfo,
        qdata: this.qdata,
        length: this.length,
        scroll: this.scroll,
        item: this.item,
        url: this.frameSrc,
        ...this.params,
      };
    },
  },

  methods: {
    dealUrl() {
      if (!this.name) {
        this.frameSrc = '#';
        return;
      }

      const { protocol, hostname } = parse(this.app, true);
      this.protocol = protocol;
      this.hostname = hostname.toLowerCase();
      let url;
      if(protocol === 'page:'){
          url = `https://git.page/jj/${hostname}`;
          if(hostname == 'header') this.header = true;
      }
      else{
        this.hostname = 'url';
        url = this.app.replace("watch?v=", "embed/")
      }
      let id=url.slice(url.lastIndexOf('/')+1);
      const newUrl = URI(url)
        .addSearch(this.params)
        .addSearch({json : JSON.stringify(this.data)})
        .addSearch({output: "embed"})
        .addSearch({dark:this.dark})
        .addSearch({playlist:id})
        .addSearch({autoplay:this.autoplay?'1':'0'})
        .addSearch({loop:this.loop?'1':'0'})
        .addSearch({app: JSON.stringify(this.appinfo)})
        .addSearch({qdata: JSON.stringify(this.qdata)});

      this.frameSrc = newUrl.toString();
    },

    dealSize() {
      const {
        x, y, w, h,
      } = this.size;
      let style = {};

      if(!this.header) style = {
          'grid-column-start': x + 1,
          'grid-column-end': x + 1 + w,
          'grid-row-start': y + 1,
          'grid-row-end': y + 1 + h,
          height: '100%',
          width: '100%',
        };
      else style = {
           'grid-column-start': x + 1,
          'grid-column-end': x + 1 + w,
          'grid-row-start': this.row,
          'grid-row-end': y + h,
          height: '48px',
          width: '100%'
        }
      this.item = style;
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-noborder {
  border: 0px none transparent;
}
.frame .frame-child{
  overflow: hidden;
  height: 100%;
  width: 100%;
 /*border: 1px solid #dbd7d7;
  overflow: hidden;
  box-shadow: 4px 5px 7px 1px #bdbcbc;*/
}

.frame .iframe-scroll {
  height: 100%;
  width: 100%;
}

.frame iframe {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.frame iframe html{
  overflow: hidden;
}
</style>
